<template>
  <Suspense>
    <template #default>
      <div class="container-hor merge-container">
        <div class="left">
          <CustomerForm v-model:selectedCustomerId="leftCustomer"></CustomerForm>

          <!--p class="debug">leftCustomer = {{ leftCustomer }}</p-->
        </div>
        <div class="middle">
          <!--FormBtn :name="'&gt;&gt; merge Left into Right &gt;&gt;'" @clicked="mergeLeftToRight"></FormBtn-->
          <button class="big-btn" type:button @click="mergeLeftToRight">
            &gt;&gt; merge Left into Right &gt;&gt;
          </button>
        </div>

        <div class="right">
          <CustomerForm v-model:selectedCustomerId="rightCustomer"></CustomerForm>
          <!--FormBtn :name="'merge Right into Left'" @clicked="mergeRightToLeft"></FormBtn-->
          <!--p class="debug">rightCustomer = {{ rightCustomer }}</p-->
        </div>
      </div>
    </template>
    <template #fallback>
      <p>suspense waiting on customer merge view...</p>
    </template>
  </Suspense>
  <Prompt @confirmed="confirmMerge"></Prompt>
</template>

<script setup lang="ts">
import { onBeforeMount, ref, watch } from 'vue'
import type { Customer } from '@/types/types'
import { useCustomerStore, usePromptStore, useAlertStore } from '@/stores'
import CustomerForm from './Customer-form.vue'
import FormBtn from '@/components/form/Form-btn.vue'
import Prompt from '@/components/Prompt.vue'
import router from '@/router'

//const leftCustomer = defineModel('leftCustomer');
//leftCustomer.value = 10;
const leftCustomer = ref(10)
//const rightCustomer = defineModel('rightCustomer');
//rightCustomer.value = 20;
const rightCustomer = ref(20)
const prompt = usePromptStore()
const customerStore = useCustomerStore()

/*
const customers = ref<Customer>();


onBeforeMount(async ()=>{
    customers.value = await customerStore.getAllCustomers();
});
*/
function mergeLeftToRight() {
  console.log('customer merge.mergeLeftToRight')
  prompt.promptUser({
    header: 'Merge Customers?',
    body: 'This will merge the customer on the left with the one on the right. After this the Customer on the left will be deleted.  Are you sure?'
  })
}

async function confirmMerge() {
  prompt.close()
  console.log('customer merge is confirmed...')
  await customerStore.mergeCustomerInto(leftCustomer.value, rightCustomer.value)
  leftCustomer.value = -1
  //router.push('/customers/manage');
}
</script>

<style lang="css" scoped>
/*.btn-footer {
  display: flex;
  flex-direction: row-reverse;
  gap: 1rem;
}*/

.emails-div {
  display: flex;
  flex-direction: row;
  gap: 4rem;
}

div.merge-container {
  justify-content: center;
  gap: 2rem;
}

button.big-btn {
  display: block;
  width: 100%;
  height: 100%;
  background-color: var(--blue);
  font-size: larger;
  border: 3px solid var(--blue);
}

button.big-btn:hover {
  border: 3px solid aqua;
}

button.big-btn:active {
  background-color: grey;
  border: 3plx solid black;
}
</style>
